// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_reduxjs_toolkit_dist_redux-toolkit_esm_js-node_modules_axios_index_js-no-dbfd3d"], () => (__webpack_require__("./src/client/index.jsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
